import styled from "styled-components";

import { Flex as BaseFlex } from "../../../../../common/styles/reusable/Flex/Flex.styles";

export const Flex = styled(BaseFlex)`
  margin-bottom: 2rem;
`;
